document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('rf-overlay');
  var popup = document.getElementById('rf-location-popup');
  var closePopupBtn = document.getElementById('rf-close-popup');
  var openDesktopBtn = document.getElementById('rf-open-location');
  var openMobileBtn = document.getElementById('rf-open-location-mobile');
  var useLocationBtn = document.getElementById('rf-use-location');
  var pincodeForm = document.getElementById('rf-pincode-form');
  var pincodeInput = document.getElementById('rf-pincode');

  var deliveryTimeDesktop = document.getElementById('rf-delivery-time');
  var addressDesktop = document.getElementById('rf-address');
  var deliveryTimeMobile = document.getElementById('rf-delivery-time-m');
  var addressMobile = document.getElementById('rf-address-m');

  var allTabSets = document.querySelectorAll('.rf-tab[data-cat]');
  var allGroups = document.querySelectorAll('.rf-subcat-group[data-group]');

  var storageKey = 'rufftail_delivery_location_v2';
  var locationStorageKeys = [
    'rufftail_delivery_location_v4',
    'rufftail_delivery_location_v3',
    'rufftail_delivery_location_v2',
    'rufftail_delivery_location',
    'rf_delivery_location',
    'rf_location'
  ];
  var popupSeenKey = 'rufftail_location_popup_seen_v1';
  var fastDeliveryThresholdCents = 149900;
  var cartTotalEtaCache = null;
  var cartTotalEtaFetchedAt = 0;
  var cartTotalEtaPromise = null;

  function normalizeHeaderLinks() {
    var linkMap = {
      'Cat Food': '/collections/dry-cat-food',
      'Treats': '/collections/dog-treats',
      'Walk Essentials': '/collections/walk-essentials',
      'Walk': '/collections/walk-essentials'
    };

    document.querySelectorAll('.rf-tabs a, .rf-bottom-nav a').forEach(function (link) {
      var label = (link.textContent || '').replace(/\s+/g, ' ').trim();
      if (linkMap[label]) link.setAttribute('href', linkMap[label]);
    });
  }

  var warehouseLat = 18.461532044582736;
  var warehouseLon = 73.83619878732844;
  var puneServiceRadiusKm = 30;
  var outerPuneRadiusKm = 90;
  var amanoraMagarpattaZone = 'amanora_magarpatta_30_min';
  var amanoraMagarpattaEta = '30 mins';
  var amanoraMagarpattaCenters = [
    { lat: 18.517023, lon: 73.9470513, radiusKm: 2.5 },
    { lat: 18.5170134, lon: 73.9270239, radiusKm: 2.5 }
  ];
  var mundhwaKharadiZone = 'mundhwa_kharadi_45_min';
  var mundhwaKharadiEta = '45 mins';
  var mundhwaKharadiCenters = [
    { lat: 18.5343218, lon: 73.9298264, radiusKm: 2.5 },
    { lat: 18.5512763, lon: 73.9416575, radiusKm: 2.5 }
  ];
  var punePincodeEtaMap = {
    '410301': { km: 29.7, eta: '90-120 mins', zone: 'pune_24_hour' },
    '410401': { km: 50.3, eta: '2-3 days', zone: 'outer_pune' },
    '410403': { km: 55.7, eta: '2-3 days', zone: 'outer_pune' },
    '410405': { km: 48.4, eta: '2-3 days', zone: 'outer_pune' },
    '410406': { km: 36.9, eta: '2-3 days', zone: 'outer_pune' },
    '410501': { km: 31.5, eta: '2-3 days', zone: 'outer_pune' },
    '410502': { km: 80.9, eta: '2-3 days', zone: 'outer_pune' },
    '410503': { km: 61.1, eta: '2-3 days', zone: 'outer_pune' },
    '410504': { km: 74.5, eta: '2-3 days', zone: 'outer_pune' },
    '410505': { km: 49, eta: '2-3 days', zone: 'outer_pune' },
    '410506': { km: 33.9, eta: '2-3 days', zone: 'outer_pune' },
    '410507': { km: 35.3, eta: '2-3 days', zone: 'outer_pune' },
    '410509': { km: 74.9, eta: '2-3 days', zone: 'outer_pune' },
    '410510': { km: 54.4, eta: '2-3 days', zone: 'outer_pune' },
    '410512': { km: 52.1, eta: '2-3 days', zone: 'outer_pune' },
    '410513': { km: 58.7, eta: '2-3 days', zone: 'outer_pune' },
    '410515': { km: 67.7, eta: '2-3 days', zone: 'outer_pune' },
    '411001': { km: 9.3, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411002': { km: 8.4, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411003': { km: 10.5, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411004': { km: 6.1, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411005': { km: 6.5, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411006': { km: 14.1, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411007': { km: 11.1, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411008': { km: 9.4, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411009': { km: 2.3, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411011': { km: 12.6, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411012': { km: 13.5, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411013': { km: 2.8, eta: '30 mins', zone: 'amanora_magarpatta_30_min' },
    '411014': { km: 5.1, eta: '45 mins', zone: 'mundhwa_kharadi_45_min' },
    '411015': { km: 15.7, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411016': { km: 8, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411017': { km: 17.2, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411018': { km: 14.3, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411019': { km: 20.5, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411020': { km: 10.8, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411021': { km: 9.9, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411022': { km: 8.9, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411023': { km: 16.2, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411024': { km: 5.7, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411025': { km: 9.8, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411026': { km: 19.7, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411027': { km: 14.7, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411028': { km: 1.7, eta: '30 mins', zone: 'amanora_magarpatta_30_min' },
    '411030': { km: 5.3, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411031': { km: 14.5, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411032': { km: 15.1, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411033': { km: 19.3, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411034': { km: 16.7, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411035': { km: 27.4, eta: '90-120 mins', zone: 'pune_24_hour' },
    '411036': { km: 2.8, eta: '45 mins', zone: 'mundhwa_kharadi_45_min' },
    '411037': { km: 9, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411038': { km: 5.9, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411039': { km: 21.4, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411040': { km: 7.4, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411041': { km: 3.1, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411042': { km: 4, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411043': { km: 2, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411044': { km: 22.7, eta: '90-120 mins', zone: 'pune_24_hour' },
    '411045': { km: 13.1, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411046': { km: 1.8, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411047': { km: 18.1, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411048': { km: 5.7, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411051': { km: 2.2, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411052': { km: 4.4, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411057': { km: 17.6, eta: '70-90 mins', zone: 'pune_24_hour' },
    '411058': { km: 4.6, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411060': { km: 8.2, eta: '35-50 mins', zone: 'pune_24_hour' },
    '411061': { km: 14.6, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411062': { km: 24, eta: '90-120 mins', zone: 'pune_24_hour' },
    '411067': { km: 11.4, eta: '50-70 mins', zone: 'pune_24_hour' },
    '411068': { km: 4.7, eta: '20-35 mins', zone: 'pune_24_hour' },
    '411069': { km: 10.6, eta: '50-70 mins', zone: 'pune_24_hour' },
    '412101': { km: 24.7, eta: '90-120 mins', zone: 'pune_24_hour' },
    '412102': { km: 26.2, eta: '90-120 mins', zone: 'pune_24_hour' },
    '412103': { km: 74.7, eta: '2-3 days', zone: 'outer_pune' },
    '412104': { km: 69.8, eta: '2-3 days', zone: 'outer_pune' },
    '412105': { km: 22.6, eta: '90-120 mins', zone: 'pune_24_hour' },
    '412106': { km: 39, eta: '2-3 days', zone: 'outer_pune' },
    '412107': { km: 21.5, eta: '70-90 mins', zone: 'pune_24_hour' },
    '412108': { km: 35.3, eta: '2-3 days', zone: 'outer_pune' },
    '412109': { km: 29.1, eta: '90-120 mins', zone: 'pune_24_hour' },
    '412110': { km: 16.3, eta: '70-90 mins', zone: 'pune_24_hour' },
    '412112': { km: 35.4, eta: '2-3 days', zone: 'outer_pune' },
    '412115': { km: 12.8, eta: '50-70 mins', zone: 'pune_24_hour' },
    '412201': { km: 20.3, eta: '70-90 mins', zone: 'pune_24_hour' },
    '412202': { km: 32.5, eta: '2-3 days', zone: 'outer_pune' },
    '412203': { km: 57.7, eta: '2-3 days', zone: 'outer_pune' },
    '412204': { km: 58.7, eta: '2-3 days', zone: 'outer_pune' },
    '412205': { km: 19.3, eta: '70-90 mins', zone: 'pune_24_hour' },
    '412206': { km: 36.2, eta: '2-3 days', zone: 'outer_pune' },
    '412207': { km: 20.8, eta: '70-90 mins', zone: 'pune_24_hour' },
    '412208': { km: 40.4, eta: '2-3 days', zone: 'outer_pune' },
    '412209': { km: 49.9, eta: '2-3 days', zone: 'outer_pune' },
    '412210': { km: 68.4, eta: '2-3 days', zone: 'outer_pune' },
    '412211': { km: 61.4, eta: '2-3 days', zone: 'outer_pune' },
    '412212': { km: 26.3, eta: '90-120 mins', zone: 'pune_24_hour' },
    '412213': { km: 16.6, eta: '70-90 mins', zone: 'pune_24_hour' },
    '412214': { km: 43.1, eta: '2-3 days', zone: 'outer_pune' },
    '412215': { km: 60.5, eta: '2-3 days', zone: 'outer_pune' },
    '412216': { km: 28.5, eta: '90-120 mins', zone: 'pune_24_hour' },
    '412218': { km: 56.7, eta: '2-3 days', zone: 'outer_pune' },
    '412219': { km: 64.6, eta: '2-3 days', zone: 'outer_pune' },
    '412301': { km: 23.3, eta: '90-120 mins', zone: 'pune_24_hour' },
    '412303': { km: 38.7, eta: '2-3 days', zone: 'outer_pune' },
    '412304': { km: 54.5, eta: '2-3 days', zone: 'outer_pune' },
    '412305': { km: 47.6, eta: '2-3 days', zone: 'outer_pune' },
    '412306': { km: 63, eta: '2-3 days', zone: 'outer_pune' },
    '412307': { km: 15.1, eta: '70-90 mins', zone: 'pune_24_hour' },
    '412308': { km: 14, eta: '50-70 mins', zone: 'pune_24_hour' },
    '412311': { km: 39.8, eta: '2-3 days', zone: 'outer_pune' },
    '412401': { km: 75.8, eta: '2-3 days', zone: 'outer_pune' },
    '412402': { km: 59, eta: '2-3 days', zone: 'outer_pune' },
    '412403': { km: 42.9, eta: '2-3 days', zone: 'outer_pune' },
    '412404': { km: 50.3, eta: '2-3 days', zone: 'outer_pune' },
    '412405': { km: 58.2, eta: '2-3 days', zone: 'outer_pune' },
    '412406': { km: 62.7, eta: '2-3 days', zone: 'outer_pune' },
    '412408': { km: 64.9, eta: '2-3 days', zone: 'outer_pune' },
    '412410': { km: 83.2, eta: '2-3 days', zone: 'outer_pune' },
    '412411': { km: 83.8, eta: '2-3 days', zone: 'outer_pune' },
    '412412': { km: 83.1, eta: '2-3 days', zone: 'outer_pune' },
    '412801': { km: 38.2, eta: '2-3 days', zone: 'outer_pune' },
    '412802': { km: 47.1, eta: '2-3 days', zone: 'outer_pune' },
    '412803': { km: 56.7, eta: '2-3 days', zone: 'outer_pune' },
    '412804': { km: 61.3, eta: '2-3 days', zone: 'outer_pune' },
    '412805': { km: 60.3, eta: '2-3 days', zone: 'outer_pune' },
    '412806': { km: 68.8, eta: '2-3 days', zone: 'outer_pune' }
  };
  var puneDeliveryTitle = '24 hour delivery';
  var puneDeliveryNote = 'For selected Pune/PCMC location';
  var outerPuneDeliveryTitle = '2-3 days';
  var outerPuneDeliveryNote = 'Outer Pune / nearby Maharashtra';

  function getPuneDeliveryWindow() {
    return {
      time: puneDeliveryTitle,
      note: puneDeliveryNote
    };
  }

  function getOuterPuneDeliveryWindow() {
    return {
      time: outerPuneDeliveryTitle,
      note: outerPuneDeliveryNote
    };
  }

  function getMinuteDeliveryEta(km) {
    if (typeof km !== 'number' || Number.isNaN(km)) return '';
    if (km <= 5) return '20-35 mins';
    if (km <= 10) return '35-50 mins';
    if (km <= 15) return '50-70 mins';
    if (km <= 22) return '70-90 mins';
    if (km <= 30) return '90-120 mins';
    return '';
  }

  function getMappedPincodeDelivery(pin) {
    var row = punePincodeEtaMap[pin];
    if (!row) return null;

    if (row.zone === mundhwaKharadiZone) {
      return getMundhwaKharadiDelivery('Pincode ' + pin + ', Mundhwa/Kharadi', row.km);
    }

    if (row.zone === amanoraMagarpattaZone) {
      return getAmanoraMagarpattaDelivery('Pincode ' + pin + ', Amanora/Magarpatta', row.km);
    }

    if (row.zone === 'pune_24_hour') {
      return {
        time: getPuneDeliveryWindow().time,
        address: 'Pincode ' + pin + ', Pune/PCMC',
        zone: row.zone,
        distance_km: row.km,
        fast_eta: row.eta
      };
    }

    if (row.zone === 'outer_pune') {
      return {
        time: getOuterPuneDeliveryWindow().time,
        address: 'Pincode ' + pin + ', Outer Pune',
        zone: row.zone,
        distance_km: row.km
      };
    }

    return null;
  }

  function getPincodeFastEta(pin) {
    var mapped = getMappedPincodeDelivery(pin);
    return mapped && mapped.fast_eta ? mapped.fast_eta : '';
  }

  function isAmanoraMagarpattaAddress(addressText) {
    return /amanora|magarpatta/i.test(addressText || '');
  }

  function isMundhwaKharadiAddress(addressText) {
    return /mundhwa|kharadi/i.test(addressText || '');
  }

  function getSpecialDeliveryZone(payload) {
    if (!payload) return '';
    var addressText = payload.address || payload.label || payload.city || '';
    var pincodeMatch = addressText.match(/\b(\d{6})\b/);

    if (isAmanoraMagarpattaAddress(addressText)) return amanoraMagarpattaZone;
    if (isMundhwaKharadiAddress(addressText)) return mundhwaKharadiZone;
    if (payload.zone === amanoraMagarpattaZone || payload.zone === mundhwaKharadiZone) return payload.zone;
    if (pincodeMatch && (pincodeMatch[1] === '411013' || pincodeMatch[1] === '411028')) return amanoraMagarpattaZone;
    if (pincodeMatch && (pincodeMatch[1] === '411014' || pincodeMatch[1] === '411036')) return mundhwaKharadiZone;
    return '';
  }

  function isAmanoraMagarpattaPayload(payload) {
    return getSpecialDeliveryZone(payload) === amanoraMagarpattaZone;
  }

  function isMundhwaKharadiPayload(payload) {
    return getSpecialDeliveryZone(payload) === mundhwaKharadiZone;
  }

  function getAmanoraMagarpattaDelivery(addressText, distanceKm) {
    var payload = {
      time: amanoraMagarpattaEta,
      address: addressText || 'Amanora/Magarpatta',
      zone: amanoraMagarpattaZone,
      fast_eta: amanoraMagarpattaEta
    };

    if (typeof distanceKm === 'number') payload.distance_km = Math.round(distanceKm * 10) / 10;
    return payload;
  }

  function getMundhwaKharadiDelivery(addressText, distanceKm) {
    var payload = {
      time: mundhwaKharadiEta,
      address: addressText || 'Mundhwa/Kharadi',
      zone: mundhwaKharadiZone,
      fast_eta: mundhwaKharadiEta
    };

    if (typeof distanceKm === 'number') payload.distance_km = Math.round(distanceKm * 10) / 10;
    return payload;
  }

  function getSpecialDeliveryFromAddress(addressText, distanceKm) {
    if (isAmanoraMagarpattaAddress(addressText)) return getAmanoraMagarpattaDelivery(addressText, distanceKm);
    if (isMundhwaKharadiAddress(addressText)) return getMundhwaKharadiDelivery(addressText, distanceKm);
    return null;
  }

  function getClosestSpecialDelivery(lat, lon) {
    var closest = null;

    function considerCenter(center, zone) {
      var distanceKm = getDistanceKm(lat, lon, center.lat, center.lon);
      if (distanceKm > center.radiusKm || (closest && distanceKm >= closest.distanceKm)) return;
      closest = { distanceKm: distanceKm, zone: zone };
    }

    amanoraMagarpattaCenters.forEach(function (center) {
      considerCenter(center, amanoraMagarpattaZone);
    });
    mundhwaKharadiCenters.forEach(function (center) {
      considerCenter(center, mundhwaKharadiZone);
    });

    if (!closest) return null;
    if (closest.zone === amanoraMagarpattaZone) {
      return getAmanoraMagarpattaDelivery('Amanora/Magarpatta');
    }
    return getMundhwaKharadiDelivery('Mundhwa/Kharadi');
  }

  function getFastEtaFromAddress(addressText) {
    var text = (addressText || '').toLowerCase();
    if (!text) return '';

    if (/amanora|magarpatta/.test(text)) return amanoraMagarpattaEta;
    if (/mundhwa|kharadi/.test(text)) return mundhwaKharadiEta;
    if (/dhayari|sinhgad|vadgaon|wadgaon|ambegaon|narhe|nanded city|kirkatwadi/.test(text)) return '20-35 mins';
    if (/kothrud|karve|warje|shivane|swargate|sahakar|bibwewadi|katraj|kondhwa|market yard/.test(text)) return '35-50 mins';
    if (/baner|aundh|pashan|bavdhan|hadapsar|magarpatta|undri|nibm|viman nagar|koregaon|camp/.test(text)) return '50-70 mins';
    if (/wakad|hinjewadi|pimple|kharadi|yerwada|dhanori|tingre|lohegaon|pimpri|chinchwad|pcmc/.test(text)) return '70-90 mins';
    return '';
  }

  function getFastEtaText(payload) {
    if (!payload) return '';
    var addressText = payload.address || payload.label || payload.city || '';
    if (payload.fast_eta) return payload.fast_eta;
    if (/mins?|minutes/i.test(payload.time || '')) return payload.time;
    if (typeof payload.distance_km === 'number') return getMinuteDeliveryEta(payload.distance_km);
    return getFastEtaFromAddress(addressText);
  }

  function fetchCartTotalForEta() {
    var now = Date.now();
    if (cartTotalEtaCache !== null && now - cartTotalEtaFetchedAt < 5000) {
      return Promise.resolve(cartTotalEtaCache);
    }
    if (cartTotalEtaPromise) return cartTotalEtaPromise;

    cartTotalEtaPromise = fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      })
      .then(function (cart) {
        cartTotalEtaCache = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
        cartTotalEtaFetchedAt = Date.now();
        cartTotalEtaPromise = null;
        return cartTotalEtaCache;
      })
      .catch(function () {
        cartTotalEtaPromise = null;
        return cartTotalEtaCache;
      });

    return cartTotalEtaPromise;
  }

  function refreshHeaderDeliveryFromCart(cartTotal) {
    var saved = getCurrentDeliveryLocation();

    if (typeof cartTotal === 'number') {
      setDeliveryUIFromPayload(saved, cartTotal);
      return Promise.resolve(cartTotal);
    }

    fetchCartTotalForEta().then(function (cartTotal) {
      setDeliveryUIFromPayload(saved, cartTotal);
    });
  }

  function isPuneEtaPayload(payload) {
    if (!payload) return false;
    var timeText = payload.time || '';
    var addressText = payload.address || payload.label || payload.city || '';
    var isOuterPune = isOuterPuneDeliveryText(timeText, addressText);
    var isNonPune = isNonPuneDayEta(timeText, addressText);
    return (
      payload.zone === amanoraMagarpattaZone ||
      payload.zone === mundhwaKharadiZone ||
      payload.zone === 'pune_24_hour' ||
      (isPuneDeliveryText(timeText, addressText) && !isOuterPune && !isNonPune)
    );
  }

  function getDeliveryDisplay(payload, cartTotal) {
    var puneWindow = getPuneDeliveryWindow();
    if (!payload) {
      return {
        time: 'Check delivery time',
        note: 'Enter pincode or use live location.',
        isPune: false,
        isLocationMissing: true
      };
    }

    var timeText = payload.time || '';
    var addressText = payload.address || payload.label || payload.city || '';

    if (isAmanoraMagarpattaPayload(payload)) {
      return {
        time: 'Delivery in 30 mins',
        note: addressText || 'Amanora/Magarpatta 30-minute service area.',
        isPune: true,
        isAmanoraMagarpatta: true,
        fastEta: amanoraMagarpattaEta
      };
    }

    if (isMundhwaKharadiPayload(payload)) {
      return {
        time: 'Delivery in 45 mins',
        note: addressText || 'Mundhwa/Kharadi 45-minute service area.',
        isPune: true,
        isMundhwaKharadi: true,
        fastEta: mundhwaKharadiEta
      };
    }

    if (isPuneEtaPayload(payload)) {
      var fastEtaText = getFastEtaText(payload);
      var showFastEta = fastEtaText && typeof cartTotal === 'number' && cartTotal >= fastDeliveryThresholdCents;
      return {
        time: showFastEta ? fastEtaText + ' delivery' : puneWindow.time,
        note: addressText ? formatPuneDeliveryAddress(addressText) : puneWindow.note,
        isPune: true,
        fastEta: fastEtaText
      };
    }

    if (isNonPuneDayEta(timeText, addressText) || isOuterPuneDeliveryText(timeText, addressText)) {
      return {
        time: formatDeliveryTimeLabel(timeText),
        note: addressText || 'Delivery timeline based on selected location.',
        isPune: false
      };
    }

    return {
      time: timeText ? formatDeliveryTimeLabel(timeText) : puneWindow.time,
      note: addressText || puneWindow.note,
      isPune: false
    };
  }

  function isPuneDeliveryText(timeText, addressText) {
    var combined = ((timeText || '') + ' ' + (addressText || '')).toLowerCase();
    return (
      /mins?|minutes|hour|hours|hr|hrs/.test(combined) ||
      combined.indexOf('pune') !== -1 ||
      combined.indexOf('pimpri') !== -1 ||
      combined.indexOf('chinchwad') !== -1 ||
      combined.indexOf('pcmc') !== -1 ||
      combined.indexOf('24 hour') !== -1 ||
      combined.indexOf('same day') !== -1 ||
      combined.indexOf('next day') !== -1
    );
  }

  function isNonPuneDayEta(timeText, addressText) {
    var combined = ((timeText || '') + ' ' + (addressText || '')).toLowerCase();
    return (
      /\b2\s*-\s*3 days?\b|\b3\s*-\s*4 days?\b|\b4\s*-\s*5 days?\b|\b4\s*-\s*6 days?\b|mumbai|hyderabad|goa|bangalore|bengaluru|new delhi|delhi|ncr|india/.test(combined) &&
      combined.indexOf('pune') === -1 &&
      combined.indexOf('pimpri') === -1 &&
      combined.indexOf('chinchwad') === -1 &&
      combined.indexOf('pcmc') === -1
    );
  }

  function isOuterPuneDeliveryText(timeText, addressText) {
    var combined = ((timeText || '') + ' ' + (addressText || '')).toLowerCase();
    return (
      /\b2\s*-\s*3 days?\b/.test(combined) ||
      combined.indexOf('outer pune') !== -1 ||
      combined.indexOf('nearby maharashtra') !== -1
    );
  }

  function formatDeliveryTimeLabel(timeText) {
    var cleaned = (timeText || '').replace(/\s+/g, ' ').trim();
    if (!cleaned) return getPuneDeliveryWindow().time;
    if (/delivery/i.test(cleaned)) return cleaned;
    if (/\b\d+\s*-\s*\d+ days?\b/i.test(cleaned)) return 'Delivery in ' + cleaned;
    return cleaned;
  }

  function formatPuneDeliveryAddress(addressText) {
    var windowText = getPuneDeliveryWindow();
    var cleaned = (addressText || '').replace(/\s+/g, ' ').trim();
    var notePattern = /\s*-\s*(order before 6:30 pm in pune|after 6:30 pm, delivery will be next day|for selected pune\/pcmc location)\.?$/i;

    if (!cleaned || /mins?|minutes|hour|hours|hr|hrs/i.test(cleaned)) return windowText.note;
    if (/order before 6:30 pm.*after 6:30 pm/i.test(cleaned)) return windowText.note;
    if (/24 hour delivery|same day delivery is available|orders? placed before 6:30 pm|delivery will be next day/i.test(cleaned)) return windowText.note;
    if (/^(for selected pune\/pcmc location|order before 6:30 pm in pune|after 6:30 pm, delivery will be next day)\.?$/i.test(cleaned)) return windowText.note;

    cleaned = cleaned.replace(notePattern, '').trim();

    return cleaned + ' - ' + windowText.note;
  }

  function normalizeDeliveryPayload(payload) {
    if (!payload || !payload.time) return payload;
    var addressText = payload.address || payload.label || payload.city || '';
    var pincodeMatch = addressText.match(/\b(\d{6})\b/);
    var mappedPincode = pincodeMatch ? getMappedPincodeDelivery(pincodeMatch[1]) : null;

    if (isAmanoraMagarpattaPayload(payload)) {
      return Object.assign(
        {},
        payload,
        getAmanoraMagarpattaDelivery(addressText, payload.distance_km)
      );
    }

    if (isMundhwaKharadiPayload(payload)) {
      return Object.assign(
        {},
        payload,
        getMundhwaKharadiDelivery(addressText, payload.distance_km)
      );
    }

    if (mappedPincode) {
      payload = Object.assign({}, payload, mappedPincode);
      if (mappedPincode.zone === 'pune_24_hour') {
        payload.cutoff_note = getPuneDeliveryWindow().note;
      } else {
        payload.cutoff_note = '';
        delete payload.fast_eta;
      }
      return payload;
    }

    if (!payload.fast_eta && /mins?|minutes/i.test(payload.time || '')) {
      payload.fast_eta = payload.time;
    }
    if (!payload.fast_eta && typeof payload.distance_km === 'number') {
      payload.fast_eta = getMinuteDeliveryEta(payload.distance_km);
    }
    if (isOuterPuneDeliveryText(payload.time, addressText)) {
      payload.time = getOuterPuneDeliveryWindow().time;
      payload.address = addressText || getOuterPuneDeliveryWindow().note;
      payload.zone = 'outer_pune';
      return payload;
    }
    if (isNonPuneDayEta(payload.time, addressText)) return payload;
    if (!isPuneDeliveryText(payload.time, addressText)) return payload;

    var windowText = getPuneDeliveryWindow();
    payload.time = windowText.time;
    payload.address = formatPuneDeliveryAddress(addressText || windowText.note);
    payload.cutoff_note = windowText.note;
    payload.zone = 'pune_24_hour';
    return payload;
  }

  function setUI(timeText, addressText) {
    setTextIfChanged(deliveryTimeDesktop, timeText);
    setTextIfChanged(addressDesktop, addressText);
    setTextIfChanged(deliveryTimeMobile, timeText);
    setTextIfChanged(addressMobile, addressText);
  }

  function setDeliveryUIFromPayload(payload, cartTotal) {
    var display = getDeliveryDisplay(payload, cartTotal);
    setUI(display.time, display.note);
  }

  function setTextIfChanged(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function saveLocation(payload) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(payload));
      localStorage.setItem(popupSeenKey, 'yes');
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('rufftail:location-updated', { detail: payload }));
  }

  function getSavedDeliveryLocation() {
    for (var i = 0; i < locationStorageKeys.length; i += 1) {
      try {
        var raw = localStorage.getItem(locationStorageKeys[i]);
        if (!raw) continue;
        var parsed = JSON.parse(raw);
        if (parsed && parsed.time) {
          parsed = normalizeDeliveryPayload(parsed) || parsed;
          localStorage.setItem(storageKey, JSON.stringify(parsed));
          return parsed;
        }
      } catch (error) {}
    }
    return null;
  }

  function getHeaderDeliveryLocation() {
    var timeText = deliveryTimeDesktop && deliveryTimeDesktop.textContent
      ? deliveryTimeDesktop.textContent
      : deliveryTimeMobile && deliveryTimeMobile.textContent
        ? deliveryTimeMobile.textContent
        : '';
    var addressText = addressDesktop && addressDesktop.textContent
      ? addressDesktop.textContent
      : addressMobile && addressMobile.textContent
        ? addressMobile.textContent
        : '';

    timeText = timeText.replace(/\s+/g, ' ').trim();
    addressText = addressText.replace(/\s+/g, ' ').trim();

    if (!timeText || /check delivery time|invalid pincode/i.test(timeText)) return null;

    return {
      time: timeText,
      address: addressText
    };
  }

  function getCurrentDeliveryLocation() {
    return normalizeDeliveryPayload(getSavedDeliveryLocation() || getHeaderDeliveryLocation());
  }

  function syncCartDeliveryEta() {
    fetchCartTotalForEta().then(function (cartTotal) {
      syncSitewideDeliveryLabels(cartTotal);
      refreshHeaderDeliveryFromCart(cartTotal);
      syncCartDeliveryEtaTargets(cartTotal);
    });
  }

  function syncCartDeliveryEtaTargets(cartTotal) {
    var targets = document.querySelectorAll('[data-rt-dynamic-eta]');
    var shortTargets = document.querySelectorAll('[data-rt-dynamic-eta-short]');
    var midMessages = document.querySelectorAll('[data-rt-delivery-mid-message]');
    var midNotes = document.querySelectorAll('[data-rt-delivery-mid-note]');
    var fastMessages = document.querySelectorAll('[data-rt-delivery-fast-message]');
    var paidNotes = document.querySelectorAll('[data-rt-delivery-paid-note]');
    var feeLabels = document.querySelectorAll('[data-rt-delivery-fee-label]');
    if (!targets.length && !shortTargets.length && !midMessages.length && !midNotes.length && !fastMessages.length && !paidNotes.length && !feeLabels.length) return;

    var saved = getCurrentDeliveryLocation();
    var timeText = saved && saved.time ? saved.time : '';
    var addressText = saved && saved.address ? saved.address : '';
    var combinedDeliveryText = (timeText + ' ' + addressText).toLowerCase();
    var isNonPuneDayEta = isNonPuneDayEtaText(combinedDeliveryText);
    var isOuterPuneEta = isOuterPuneDeliveryText(timeText, addressText);
    var isPuneEta = isPuneDeliveryText(timeText, addressText) && !isNonPuneDayEta && !isOuterPuneEta;
    var isAmanoraMagarpatta = isAmanoraMagarpattaPayload(saved);
    var isMundhwaKharadi = isMundhwaKharadiPayload(saved);
    var fastEtaText = getFastEtaText(saved);
    var display = getDeliveryDisplay(saved, cartTotal);

    if (display.isLocationMissing) {
      targets.forEach(function (target) {
        setTextIfChanged(target, 'Check delivery time to see ETA.');
      });
      shortTargets.forEach(function (target) {
        setTextIfChanged(target, display.time);
      });
      midNotes.forEach(function (target) {
        setTextIfChanged(target, display.note);
      });
      fastMessages.forEach(function (target) {
        setTextIfChanged(target, 'Check delivery time to see ETA.');
      });
      paidNotes.forEach(function (target) {
        setTextIfChanged(target, display.note);
      });
      feeLabels.forEach(function (target) {
        setTextIfChanged(target, display.time);
      });
      return;
    }

    var etaText = timeText
      ? 'ETA: ' + formatDeliveryTimeLabel(timeText) + (addressText ? ' for ' + addressText : ' from your selected location') + '.'
      : 'ETA depends on selected location or pincode.';
    var fastEtaFullText = fastEtaText
      ? 'Fast delivery ETA: ' + fastEtaText + (addressText ? ' for ' + addressText : ' from your selected location') + '.'
      : etaText;
    var shortEtaText = timeText
      ? formatDeliveryTimeLabel(timeText) + (addressText ? ' for ' + addressText : '')
      : getPuneDeliveryWindow().time;
    var standardEtaText = timeText
      ? 'Delivery ETA: ' + shortEtaText + '.'
      : 'Delivery ETA depends on selected location or pincode.';
    var selectedLocationEtaText = isAmanoraMagarpatta
      ? display.time + '. ' + display.note + '.'
      : isMundhwaKharadi
      ? display.time + '. ' + display.note + '.'
      : isPuneEta
      ? getPuneDeliveryWindow().time + '. ' + getPuneDeliveryWindow().note + '.'
      : standardEtaText;

    targets.forEach(function (target) {
      setTextIfChanged(target, isPuneEta && fastEtaText ? fastEtaFullText : etaText);
    });

    shortTargets.forEach(function (target) {
      setTextIfChanged(target, display.time || shortEtaText);
    });

    midMessages.forEach(function (target) {
      var remaining = target.getAttribute('data-remaining') || '';
      setTextIfChanged(
        target,
        isAmanoraMagarpatta
          ? 'Free delivery unlocked. Delivery in 30 mins for Amanora/Magarpatta.'
          : isMundhwaKharadi
          ? 'Free delivery unlocked. Delivery in 45 mins for Mundhwa/Kharadi.'
          : isPuneEta
          ? 'Free delivery unlocked. ' + getPuneDeliveryWindow().time + ' for Pune/PCMC.'
          : 'Free delivery unlocked.'
      );
    });

    midNotes.forEach(function (target) {
      setTextIfChanged(target, selectedLocationEtaText);
    });

    fastMessages.forEach(function (target) {
      var fastEtaMessage = isPuneEta && fastEtaText
        ? 'Fast delivery: ' + fastEtaText + '.'
        : timeText
        ? selectedLocationEtaText
        : 'Delivery ETA depends on selected location or pincode.';
      setTextIfChanged(
        target,
        fastEtaMessage
      );
    });

    paidNotes.forEach(function (target) {
      setTextIfChanged(target, selectedLocationEtaText);
    });

    feeLabels.forEach(function (target) {
      var feeEtaLabel = 'Free delivery';

      if (isPuneEta && fastEtaText) {
        feeEtaLabel = 'Fast delivery: ' + fastEtaText;
      } else if (isPuneEta) {
        feeEtaLabel = getPuneDeliveryWindow().time;
      } else if (timeText) {
        feeEtaLabel = formatDeliveryTimeLabel(timeText);
      }

      setTextIfChanged(target, feeEtaLabel);
    });
  }

  function getDeliveryPromiseSnapshot(cart) {
    var freeDeliveryThreshold = 59900;
    var fastDeliveryThreshold = 149900;
    var saved = getCurrentDeliveryLocation() || {};
    var cartTotal = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var timeText = saved.time || '';
    var addressText = saved.address || saved.label || saved.city || '';
    var zone = saved.zone || '';
    var fastEta = saved.fast_eta || '';
    var isAmanoraMagarpatta = isAmanoraMagarpattaPayload(saved);
    var isMundhwaKharadi = isMundhwaKharadiPayload(saved);
    var isOuterPuneEta = isOuterPuneDeliveryText(timeText, addressText) || zone === 'outer_pune';
    var isNonPuneEta = isNonPuneDayEta(timeText, addressText);
    var isPuneEta = zone === 'pune_24_hour' || (isPuneDeliveryText(timeText, addressText) && !isOuterPuneEta && !isNonPuneEta);
    var promise = '';
    var rule = '';
    var pincodeMatch = addressText.match(/\b(\d{6})\b/);
    var source = pincodeMatch ? 'Pincode' : saved.distance_km ? 'Live location / distance' : 'Storefront default';
    var splitMarker = document.querySelector('[data-rt-cart-delivery-split]');
    var splitState = splitMarker ? splitMarker.getAttribute('data-rt-cart-delivery-split') || '' : '';

    if (!fastEta && isPuneEta && typeof saved.distance_km === 'number') {
      fastEta = getMinuteDeliveryEta(saved.distance_km);
    }
    if (!fastEta && isPuneEta) {
      fastEta = getFastEtaFromAddress(addressText);
    }

    if (splitState === 'mixed') {
      promise = 'Split delivery: 30-minute + Same-day';
      rule = 'One checkout; items may arrive in two deliveries from separate Rufftail hubs.';
      source = 'Cart fulfilment groups';
    } else if (isAmanoraMagarpatta) {
      promise = amanoraMagarpattaEta;
      rule = cartTotal < freeDeliveryThreshold
        ? 'Amanora/Magarpatta 30-minute zone; Rs 49 delivery fee applies below Rs 599.'
        : 'Amanora/Magarpatta 30-minute zone; free delivery applies from Rs 599.';
    } else if (isMundhwaKharadi) {
      promise = mundhwaKharadiEta;
      rule = cartTotal < freeDeliveryThreshold
        ? 'Mundhwa/Kharadi 45-minute zone; Rs 49 delivery fee applies below Rs 599.'
        : 'Mundhwa/Kharadi 45-minute zone; free delivery applies from Rs 599.';
    } else if (cartTotal < freeDeliveryThreshold) {
      promise = isPuneEta
        ? getPuneDeliveryWindow().time
        : timeText
          ? formatDeliveryTimeLabel(timeText)
          : 'Delivery ETA depends on selected location or pincode';
      rule = 'Below Rs 599: Rs 49 delivery fee applies; ETA by selected location.';
    } else if (cartTotal < fastDeliveryThreshold) {
      promise = isPuneEta
        ? getPuneDeliveryWindow().time
        : timeText
          ? formatDeliveryTimeLabel(timeText)
          : 'Delivery ETA depends on selected location or pincode';
      rule = 'Rs 599 to Rs 1,498: free delivery; no minute ETA commitment.';
    } else if (isPuneEta && fastEta) {
      promise = fastEta;
      rule = 'Rs 1,499+: fast Pune/PCMC ETA based on selected pincode or live location.';
    } else if (isPuneEta) {
      promise = getPuneDeliveryWindow().time;
      rule = 'Rs 1,499+: Pune/PCMC selected, but minute ETA was unavailable.';
    } else if (isOuterPuneEta) {
      promise = getOuterPuneDeliveryWindow().time;
      rule = 'Outer Pune / nearby Maharashtra.';
    } else {
      promise = timeText ? formatDeliveryTimeLabel(timeText) : 'Delivery ETA depends on selected location or pincode';
      rule = 'Standard shipping ETA by location.';
    }

    return {
      promise: promise,
      location: addressText || 'Not selected',
      zone: splitState === 'mixed' ? 'Multiple Rufftail hubs' : isAmanoraMagarpatta ? 'Amanora/Magarpatta 30-minute zone' : isMundhwaKharadi ? 'Mundhwa/Kharadi 45-minute zone' : isPuneEta ? 'Pune/PCMC' : isOuterPuneEta ? 'Outer Pune' : zone || 'Standard / unknown',
      distance: typeof saved.distance_km === 'number' ? String(saved.distance_km) : '',
      source: source,
      rule: rule,
      cartTotal: cartTotal
    };
  }

  function formatPromiseMoney(cents) {
    return 'Rs ' + Math.round(Number(cents || 0) / 100).toLocaleString('en-IN');
  }

  function getDeliveryPromiseAttributes(cart) {
    var snapshot = getDeliveryPromiseSnapshot(cart);
    var attrs = {
      'Delivery promise': snapshot.promise,
      'Delivery location': snapshot.location,
      'Delivery zone': snapshot.zone,
      'Delivery promise source': snapshot.source,
      'Delivery rule': snapshot.rule,
      'Cart value at promise': formatPromiseMoney(snapshot.cartTotal),
      'Delivery captured at': new Date().toISOString()
    };

    if (snapshot.distance) attrs['Delivery distance km'] = snapshot.distance;
    return attrs;
  }

  function syncOrderDeliveryPromise() {
    return fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      })
      .then(function (cart) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: getDeliveryPromiseAttributes(cart)
          })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Delivery promise sync failed');
        return response.json();
      });
  }

  function syncOrderDeliveryPromiseWithTimeout(timeoutMs) {
    var isDone = false;

    return new Promise(function (resolve) {
      var timer = window.setTimeout(function () {
        if (isDone) return;
        isDone = true;
        resolve();
      }, timeoutMs || 2500);

      syncOrderDeliveryPromise()
        .catch(function () {
          return null;
        })
        .then(function () {
          if (isDone) return;
          isDone = true;
          window.clearTimeout(timer);
          resolve();
        });
    });
  }

  function prepareCheckoutWithDeliveryPromise(button, event) {
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
    if (button.dataset.rtDeliveryPromiseSyncing === 'true') return true;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var originalText = button.textContent;
    button.dataset.rtDeliveryPromiseSyncing = 'true';
    button.dataset.rtDeliveryPromiseOriginalText = originalText;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Opening secure checkout...';

    syncOrderDeliveryPromiseWithTimeout(2500)
      .then(function () {
        window.location.assign('/checkout');
      });

    return true;
  }

  function bindDeliveryPromiseCheckoutSync() {
    if (document.documentElement.dataset.rtDeliveryPromiseCheckoutBound === 'true') return;
    document.documentElement.dataset.rtDeliveryPromiseCheckoutBound = 'true';

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;
      var button = event.target.closest('[name="checkout"], .rf-cart__sticky-btn');
      if (!button) return;
      prepareCheckoutWithDeliveryPromise(button, event);
    });

    document.addEventListener('submit', function (event) {
      if (event.defaultPrevented) return;
      var submitter = event.submitter || document.activeElement;
      if (!submitter || submitter.name !== 'checkout') return;
      prepareCheckoutWithDeliveryPromise(submitter, event);
    });
  }

  function isNonPuneDayEtaText(text) {
    var combined = (text || '').toLowerCase();
    return (
      /\b2\s*-\s*3 days?\b|\b3\s*-\s*4 days?\b|\b4\s*-\s*5 days?\b|\b4\s*-\s*6 days?\b|mumbai|hyderabad|goa|bangalore|bengaluru|new delhi|delhi|ncr|india/.test(combined) &&
      combined.indexOf('pune') === -1 &&
      combined.indexOf('pimpri') === -1 &&
      combined.indexOf('chinchwad') === -1 &&
      combined.indexOf('pcmc') === -1
    );
  }

  function shouldNormalizeVisibleEta(text) {
    if (!text || isNonPuneDayEtaText(text)) return false;
    return (
      isPuneDeliveryText(text, '') ||
      /20\s*-\s*35|30\s*-\s*60|mins?|minutes?|1\s*hour|24\s*hour|same day pune delivery|pune delivery/i.test(text)
    );
  }

  function getCurrentDeliveryDisplay(cartTotal) {
    if (typeof cartTotal !== 'number' && cartTotalEtaCache !== null) {
      cartTotal = cartTotalEtaCache;
    }

    var saved = getCurrentDeliveryLocation();
    return getDeliveryDisplay(saved, cartTotal);
  }

  function syncSitewideDeliveryLabels(cartTotal) {
    var display = getCurrentDeliveryDisplay(cartTotal);
    var titleSelectors = [
      '[data-home-delivery-title]',
      '.rufftail-delivery-card__title',
      '[data-delivery-card-title]',
      '[data-rt-dynamic-eta-short]'
    ].join(',');
    var subtitleSelectors = [
      '[data-home-delivery-subtitle]',
      '.rufftail-delivery-card__subtitle',
      '[data-delivery-card-subtitle]',
      '[data-live-eta-message]'
    ].join(',');

    document.querySelectorAll(titleSelectors).forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || (!display.isLocationMissing && !shouldNormalizeVisibleEta(text))) return;
      setTextIfChanged(node, display.time);
    });

    document.querySelectorAll(subtitleSelectors).forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || (!display.isLocationMissing && !shouldNormalizeVisibleEta(text) && !display.isPune)) return;
      setTextIfChanged(node, display.isAmanoraMagarpatta || display.isMundhwaKharadi ? display.note : display.isPune ? formatPuneDeliveryAddress(display.note) : display.note);
    });
  }

  function restoreLocation() {
    try {
      var parsed = getSavedDeliveryLocation();
      if (parsed && parsed.time && parsed.address) {
        parsed = normalizeDeliveryPayload(parsed);
        saveLocation(parsed);
        setDeliveryUIFromPayload(parsed);
        refreshHeaderDeliveryFromCart();
        syncCartDeliveryEta();
        return true;
      }
    } catch (error) {}
    return false;
  }

  function openPopup() {
    if (popup) {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
    }
    if (overlay) {
      overlay.classList.add('is-open');
    }
    document.body.classList.add('rf-location-popup-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (popup) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
    }
    if (overlay) {
      overlay.classList.remove('is-open');
    }
    document.body.classList.remove('rf-location-popup-open');
    document.body.style.overflow = '';
  }

  function attachOpen(el) {
    if (el) el.addEventListener('click', openPopup);
  }

  attachOpen(openDesktopBtn);
  attachOpen(openMobileBtn);
  normalizeHeaderLinks();

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('#rf-open-location, #rf-open-location-mobile, .rf-location-trigger');
    if (!trigger) return;
    event.preventDefault();
    openPopup();
  });

  if (closePopupBtn) closePopupBtn.addEventListener('click', closePopup);
  if (overlay) overlay.addEventListener('click', closePopup);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  function toRad(value) {
    return value * Math.PI / 180;
  }

  function getDistanceKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function getDistanceDeliveryWindow(km) {
    var minuteEta = getMinuteDeliveryEta(km);
    if (km <= puneServiceRadiusKm) {
      return {
        time: getPuneDeliveryWindow().time,
        note: getPuneDeliveryWindow().note,
        zone: 'pune_24_hour',
        distance_km: Math.round(km * 10) / 10,
        fast_eta: minuteEta
      };
    }
    if (km <= outerPuneRadiusKm) {
      return {
        time: getOuterPuneDeliveryWindow().time,
        note: getOuterPuneDeliveryWindow().note,
        zone: 'outer_pune',
        distance_km: Math.round(km * 10) / 10
      };
    }
    return null;
  }

  function getNonPuneEstimate(city, fullAddress) {
    var combined = ((city || '') + ' ' + (fullAddress || '')).toLowerCase();

    if (combined.indexOf('mumbai') !== -1) return '3-4 days';
    if (combined.indexOf('hyderabad') !== -1) return '3-4 days';
    if (
      combined.indexOf('goa') !== -1 ||
      combined.indexOf('panaji') !== -1 ||
      combined.indexOf('margao') !== -1 ||
      combined.indexOf('vasco') !== -1
    ) return '3-4 days';
    if (
      combined.indexOf('bangalore') !== -1 ||
      combined.indexOf('bengaluru') !== -1
    ) return '4-5 days';
    if (
      combined.indexOf('new delhi') !== -1 ||
      combined.indexOf('delhi') !== -1 ||
      combined.indexOf('ncr') !== -1 ||
      combined.indexOf('gurgaon') !== -1 ||
      combined.indexOf('gurugram') !== -1 ||
      combined.indexOf('noida') !== -1
    ) return '4-5 days';

    return '4-6 days';
  }

  function normalizeAddress(addressObj) {
    var area =
      addressObj.neighbourhood ||
      addressObj.suburb ||
      addressObj.quarter ||
      addressObj.road ||
      addressObj.city_district ||
      addressObj.village ||
      addressObj.hamlet ||
      '';

    var city =
      addressObj.city ||
      addressObj.town ||
      addressObj.county ||
      addressObj.state_district ||
      addressObj.state ||
      '';

    var parts = [];
    if (area) parts.push(area);
    if (city) parts.push(city);

    return {
      area: area,
      city: city,
      fullAddress: parts.join(', ')
    };
  }

  function updateAndStore(timeText, addressText, meta) {
    var payload = Object.assign({}, meta || {}, {
      time: timeText,
      address: addressText
    });

    payload = normalizeDeliveryPayload(payload) || payload;
    setDeliveryUIFromPayload(payload);
    saveLocation(payload);
    syncCartDeliveryEta();
  }

  function resolveLocation(lat, lon) {
    var km = getDistanceKm(lat, lon, warehouseLat, warehouseLon);
    var distanceEta = getDistanceDeliveryWindow(km);
    var closestSpecialDelivery = getClosestSpecialDelivery(lat, lon);

    fetch(
      'https://nominatim.openstreetmap.org/reverse?format=json&lat=' +
        encodeURIComponent(lat) +
        '&lon=' +
        encodeURIComponent(lon) +
        '&addressdetails=1',
      {
        headers: {
          'Accept-Language': 'en'
        }
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var addressObj = (data && data.address) || {};
        var normalized = normalizeAddress(addressObj);
        var cityText = (normalized.city || '').toLowerCase();
        var addressText = normalized.fullAddress || 'Your location';
        var namedSpecialDelivery = getSpecialDeliveryFromAddress(addressText);
        var specialDelivery = namedSpecialDelivery || closestSpecialDelivery;

        var isPuneArea =
          km <= puneServiceRadiusKm ||
          cityText.indexOf('pune') !== -1 ||
          cityText.indexOf('pimpri') !== -1 ||
          cityText.indexOf('chinchwad') !== -1 ||
          cityText.indexOf('pcmc') !== -1 ||
          addressText.toLowerCase().indexOf('pune') !== -1 ||
          addressText.toLowerCase().indexOf('pimpri') !== -1 ||
          addressText.toLowerCase().indexOf('chinchwad') !== -1;

        if (specialDelivery) {
          updateAndStore(
            specialDelivery.time,
            addressText || specialDelivery.address,
            Object.assign({}, specialDelivery, { address: addressText || specialDelivery.address })
          );
        } else if (isPuneArea && distanceEta && distanceEta.zone === 'pune_24_hour') {
          updateAndStore(distanceEta.time, addressText || distanceEta.note, distanceEta);
        } else if ((distanceEta && distanceEta.zone === 'outer_pune') || isPuneArea) {
          updateAndStore(getOuterPuneDeliveryWindow().time, addressText || getOuterPuneDeliveryWindow().note, distanceEta || { zone: 'outer_pune' });
        } else {
          updateAndStore(getNonPuneEstimate(normalized.city, addressText), addressText);
        }

        closePopup();
      })
      .catch(function () {
        if (closestSpecialDelivery) {
          updateAndStore(
            closestSpecialDelivery.time,
            closestSpecialDelivery.address,
            closestSpecialDelivery
          );
        } else if (distanceEta) {
          updateAndStore(distanceEta.time, distanceEta.note, distanceEta);
        } else {
          updateAndStore('4-6 days', 'India');
        }
        closePopup();
      });
  }

  if (useLocationBtn) {
    useLocationBtn.addEventListener('click', function () {
      if (!navigator.geolocation) {
        setUI('Check delivery time', 'Geolocation not supported. Use pincode.');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        function (position) {
          resolveLocation(position.coords.latitude, position.coords.longitude);
        },
        function () {
          setUI('Check delivery time', 'Location denied. Use pincode.');
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000
        }
      );
    });
  }

  function pincodeLogic(pin) {
    var mappedDelivery = getMappedPincodeDelivery(pin);
    if (mappedDelivery) return mappedDelivery;

    if (/^411\d{3}$/.test(pin)) {
      return {
        time: getPuneDeliveryWindow().time,
        address: 'Pincode ' + pin + ', Pune/PCMC',
        zone: 'pune_24_hour'
      };
    }

    if (/^(410|412)\d{3}$/.test(pin)) {
      return {
        time: getOuterPuneDeliveryWindow().time,
        address: 'Pincode ' + pin + ', Outer Pune',
        zone: 'outer_pune'
      };
    }

    if (/^40[34]\d{3}$/.test(pin)) {
      return {
        time: '3-4 days',
        address: 'Pincode ' + pin + ', Goa'
      };
    }

    if (/^40\d{4}$/.test(pin)) {
      return {
        time: '3-4 days',
        address: 'Pincode ' + pin + ', Mumbai'
      };
    }

    if (/^50\d{4}$/.test(pin)) {
      return {
        time: '3-4 days',
        address: 'Pincode ' + pin + ', Hyderabad'
      };
    }

    if (/^56\d{4}$/.test(pin)) {
      return {
        time: '4-5 days',
        address: 'Pincode ' + pin + ', Bangalore'
      };
    }

    if (/^11\d{4}$/.test(pin) || /^12\d{4}$/.test(pin)) {
      return {
        time: '4-5 days',
        address: 'Pincode ' + pin + ', New Delhi'
      };
    }

    if (/^41\d{4}$/.test(pin)) {
      return {
        time: getOuterPuneDeliveryWindow().time,
        address: 'Pincode ' + pin + ', Maharashtra',
        zone: 'outer_pune'
      };
    }

    return {
      time: '4-6 days',
      address: 'Pincode ' + pin + ', India'
    };
  }

  if (pincodeForm) {
    pincodeForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var pin = (pincodeInput.value || '').trim();

      if (!/^\d{6}$/.test(pin)) {
        setUI('Invalid pincode', 'Enter a valid 6 digit pincode');
        return;
      }

      var result = pincodeLogic(pin);
      updateAndStore(result.time, result.address, result);
      closePopup();
    });
  }

  function setActiveCategory(cat) {
    allTabSets.forEach(function (tab) {
      if (tab.getAttribute('data-cat') === cat) {
        tab.classList.add('is-active');
      } else if (tab.hasAttribute('data-cat')) {
        tab.classList.remove('is-active');
      }
    });

    allGroups.forEach(function (group) {
      if (group.getAttribute('data-group') === cat) {
        group.classList.add('is-active');
      } else {
        group.classList.remove('is-active');
      }
    });
  }

  allTabSets.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var cat = tab.getAttribute('data-cat');
      if (cat) setActiveCategory(cat);
    });
  });

  function detectCurrentCategory() {
    var path = window.location.pathname.toLowerCase();

    if (path.indexOf('/collections/cat') !== -1 || path.indexOf('/collections/cats') !== -1) {
      setActiveCategory('cats');
      return;
    }

    if (path.indexOf('/collections/dog') !== -1 || path.indexOf('/collections/dogs') !== -1) {
      setActiveCategory('dogs');
      return;
    }

    setActiveCategory('all');
  }

  if (!restoreLocation()) {
    setUI('Check delivery time', 'Enter pincode or use live location.');
  }

  detectCurrentCategory();
  syncCartDeliveryEta();
  bindDeliveryPromiseCheckoutSync();
  document.addEventListener('rufftail:location-updated', syncCartDeliveryEta);
  document.addEventListener('cart:updated', function () {
    cartTotalEtaCache = null;
    cartTotalEtaFetchedAt = 0;
    syncCartDeliveryEta();
  });
  document.addEventListener('shopify:section:load', syncCartDeliveryEta);
  window.addEventListener('storage', function (event) {
    if (locationStorageKeys.indexOf(event.key) !== -1) {
      restoreLocation();
      syncCartDeliveryEta();
    }
  });

  var etaSyncTimer;
  function scheduleEtaSync() {
    window.clearTimeout(etaSyncTimer);
    etaSyncTimer = window.setTimeout(syncCartDeliveryEta, 80);
  }

  if (window.MutationObserver) {
    var etaSyncSelector = '[data-rt-dynamic-eta], [data-rt-dynamic-eta-short], [data-rt-delivery-mid-message], [data-rt-delivery-mid-note], [data-rt-delivery-fast-message], [data-rt-delivery-paid-note], [data-rt-delivery-fee-label], [data-home-delivery-title], [data-home-delivery-subtitle], .rufftail-delivery-card__title, .rufftail-delivery-card__subtitle, [data-delivery-card-title], [data-delivery-card-subtitle], [data-live-eta-message], cart-drawer, .cart-drawer, .rf-cart';
    var cartEtaObserver = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        if (mutation.type === 'characterData') {
          var parent = mutation.target && mutation.target.parentElement;
          return !!(parent && (parent.matches(etaSyncSelector) || parent.closest(etaSyncSelector)));
        }

        if (mutation.type !== 'childList') return false;
        if (mutation.target && mutation.target.nodeType === 1 && mutation.target.matches(etaSyncSelector)) return true;

        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          return (
            node.matches(etaSyncSelector) ||
            node.querySelector(etaSyncSelector)
          );
        });
      });
      if (shouldSync) scheduleEtaSync();
    });
    cartEtaObserver.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  setTimeout(syncCartDeliveryEta, 250);
  setTimeout(syncCartDeliveryEta, 1000);
  setTimeout(syncCartDeliveryEta, 2500);
  setTimeout(syncCartDeliveryEta, 4000);

  window.RufftailDeliveryEta = {
    getPuneDeliveryWindow: getPuneDeliveryWindow,
    getPincodeDelivery: pincodeLogic,
    getMappedPincodeDelivery: getMappedPincodeDelivery,
    getMinuteDeliveryEta: getMinuteDeliveryEta,
    getDeliveryDisplay: getDeliveryDisplay,
    getCurrentDisplay: getCurrentDeliveryDisplay,
    normalizeDeliveryPayload: normalizeDeliveryPayload,
    getDeliveryPromiseAttributes: getDeliveryPromiseAttributes,
    syncOrderDeliveryPromise: syncOrderDeliveryPromise,
    sync: syncCartDeliveryEta
  };
});
